import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`

* {
  padding: 0px;
  margin: 0px;
  font-family: "Graphik Compact";
  font-weight: 300;
}

html,
body {
  width: 100%;
  height: 100vh;
  overflow-x: hidden;
  scroll-behavior: smooth;
  background-color: ${({ theme }) => theme.color.bg};
}

input {
  color: ${({ theme }) => theme.color.black};
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${({ theme }) => theme.color.blue.primary};
    opacity: 1; /* Firefox */
    font-family: "Graphik Compact", sans-serif;
    font-weight: 300;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${({ theme }) => theme.color.blue.primary};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${({ theme }) => theme.color.blue.primary};
  }
}

.tooltip {
  --tooltip-offset: calc(100% + var(--tooltip-tail, 0px))
}
`

export default GlobalStyles
